import { QueryKeys } from "@lib/enums/QueryKeys";
import type { QueryConfig } from "@lib/helpers/useApi";
import { useApi } from "@lib/helpers/useApi";
import { getUser } from "@lib/utils/user-api/getUserWithErrorHandler";
import type { Customer } from "@store/types";
import { useSession } from "next-auth/react";
import useSignOut from "./useSignOut";

type UseProfileParams<TData = Customer> = {
    // Allow extending queryConfig, including select
    queryConfig?: QueryConfig<Customer, TData>;
};

export const useProfile = <TData = Customer>(params?: UseProfileParams<TData>) => {
    const { queryConfig } = params ?? {};
    const { data: session, status } = useSession();
    const { signOut } = useSignOut();

    const queryConfigWithDefaults = {
        enabled: status === "authenticated",
        ...(queryConfig ?? {}),
    };

    return useApi.useAsync<Customer, TData>(
        [QueryKeys.getProfile, session?.anonymousId, session?.ucid],
        async () => {
            if (!session?.ucid) {
                return {} as Customer;
            }
            return await getUser(signOut);
        },
        queryConfigWithDefaults
    );
};
